export const bookTagCategories = [
  { id: 'all', label: 'Alle', icon: '🎲' },
  { id: 'country', label: 'Country', icon: '🌍' },
  { id: 'era', label: 'Epoche/Jahrzehnt', icon: '📅' },
  { id: 'subject', label: 'Thema/Fachgebiet', icon: '📚' },
  { id: 'genre', label: 'Genre', icon: '📖' },
  { id: 'format', label: 'Format', icon: '🗂️' },
  { id: 'mood', label: 'Stimmung', icon: '😊' },
  { id: 'theme', label: 'Thema', icon: '🎯' },
  { id: 'misc', label: 'Misc', icon: '📌' }
];

export const bookFavsConfig = {
  apiPath: '/api/book-favs',
  slug: 'bookfavs',
  title: 'book-favs',
  typeLabel: 'Kategorie',
  nameLabel: 'Buchtitel',
  artistLabel: 'Autor*in',
  personField: 'author',
  entryTypes: [
    { value: 'belletristik', label: 'Belletristik' },
    { value: 'sachbuch', label: 'Sachbuch' },
    { value: 'philosophie', label: 'Philosophie' },
    { value: 'soziologie', label: 'Soziologie' },
    { value: 'musiktheorie', label: 'Musiktheorie' }
  ],
  typeFilters: [
    { value: 'both', label: 'all' },
    { value: 'belletristik', label: 'Belletristik' },
    { value: 'sachbuch', label: 'Sachbuch' },
    { value: 'philosophie', label: 'Philosophie' },
    { value: 'soziologie', label: 'Soziologie' },
    { value: 'musiktheorie', label: 'Musiktheorie' }
  ],
  typeLabels: {
    belletristik: '📖 Belletristik',
    sachbuch: '📚 Sachbuch',
    philosophie: '💭 Philosophie',
    soziologie: '👥 Soziologie',
    musiktheorie: '🎼 Musiktheorie'
  },
  exportTypeLabels: {
    belletristik: 'Belletristik',
    sachbuch: 'Sachbuch',
    philosophie: 'Philosophie',
    soziologie: 'Soziologie',
    musiktheorie: 'Musiktheorie'
  },
  tagCategories: bookTagCategories,
  searchPlaceholder: 'Buchtitel, Autor*in oder Beschreibung...'
};
